module.exports = __webpack_public_path__ + "img/icon_7@2x.634f02ec.svg";